const StyleG = () => {
  return (
    <div className="style-g">
      <style>{`
        .style-g {
          --bg-primary: #ffffff;
          --bg-secondary: #f9f9f9;
          --bg-offset: #f4f4f4;
          --text-primary: #1c1c1c;
          --text-secondary: #4a4a4a;
          --text-light: #6b6b6b;
          --accent-primary: #000000;
          --accent-soft: #3a3a3a;
          --border-main: #d4d4d4;
          --border-light: #eeeeee;
          --shadow-soft: rgba(0, 0, 0, 0.04);
        }
        
        .style-g.dark {
          --bg-primary: #fdfdfd;
          --bg-secondary: #f7f7f7;
          --bg-offset: #f1f1f1;
          --text-primary: #0a0a0a;
          --text-secondary: #333333;
          --text-light: #555555;
          --accent-primary: #000000;
          --accent-soft: #222222;
          --border-main: #c8c8c8;
          --border-light: #e2e2e2;
          --shadow-soft: rgba(0, 0, 0, 0.06);
        }

        .style-g {
          background: var(--bg-primary);
          color: var(--text-primary);
          font-family: 'Inter', sans-serif;
          line-height: 1.6;
        }
        
        .style-g h1 {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 3rem;
          line-height: 1.1;
          margin-bottom: 1rem;
          color: var(--text-primary);
          text-align: left;
          letter-spacing: -0.025em;
        }
        
        .style-g h2 {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 2rem;
          line-height: 1.2;
          margin-bottom: 1rem;
          color: var(--text-primary);
          text-align: left;
          letter-spacing: -0.02em;
        }
        
        .style-g h3 {
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          font-size: 1.25rem;
          margin-bottom: 0.75rem;
          color: var(--text-secondary);
          text-align: left;
        }
        
        .style-g .asymmetric-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        
        .style-g .playful-section {
          margin: 4rem 0;
          display: grid;
          grid-template-columns: 2fr 3fr;
          gap: 3rem;
          align-items: start;
        }
        
        .style-g .offset-card {
          background: var(--bg-secondary);
          border: 1px solid var(--border-light);
          border-radius: 10px;
          padding: 2rem;
          margin: 1rem 0;
          position: relative;
          transition: all 0.2s ease;
        }
        
        .style-g .offset-card:nth-child(even) {
          margin-left: 2rem;
          background: var(--bg-offset);
        }
        
        .style-g .offset-card:nth-child(odd) {
          margin-right: 1rem;
        }
        
        .style-g .offset-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px var(--shadow-soft);
        }
        
        .style-g .contemporary-text {
          font-size: 1.05rem;
          color: var(--text-secondary);
          font-weight: 400;
          line-height: 1.65;
        }
        
        .style-g .dignified-accent {
          color: var(--accent-soft);
          font-weight: 500;
          border-bottom: 1px solid var(--border-main);
          padding-bottom: 1px;
        }
        
        .style-g .layout-break {
          margin: 3rem 0;
          padding: 2.5rem 0;
          border-left: 4px solid var(--accent-primary);
          padding-left: 2rem;
        }
        
        .style-g .staggered-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin: 2rem 0;
        }
        
        .style-g .staggered-grid > div:first-child {
          margin-top: 0;
        }
        
        .style-g .staggered-grid > div:last-child {
          margin-top: 2rem;
        }
        
        .style-g .contemporary-button {
          background: var(--accent-primary);
          color: var(--bg-primary);
          border: none;
          padding: 1rem 2rem;
          border-radius: 8px;
          font-weight: 500;
          font-size: 1rem;
          transition: all 0.2s ease;
          margin-top: 1rem;
        }
        
        .style-g .contemporary-button:hover {
          background: var(--accent-soft);
          transform: translateX(4px);
        }
        
        .style-g .side-note {
          background: var(--bg-offset);
          border-left: 3px solid var(--accent-primary);
          padding: 1.5rem;
          margin: 2rem 0;
          font-style: italic;
          color: var(--text-light);
          font-size: 0.95rem;
        }
        
        .style-g .flowing-section {
          margin: 3rem 0;
        }
        
        .style-g .flowing-section > * {
          max-width: 65ch;
        }
        
        .style-g .flowing-section h2 {
          max-width: none;
        }
        
        .style-g .creative-emphasis {
          display: inline-block;
          background: var(--bg-secondary);
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-weight: 500;
          margin: 0 0.125rem;
        }
        
        .style-g .varied-alignment {
          text-align: left;
        }
        
        .style-g .varied-alignment:nth-of-type(3n) {
          text-align: right;
          margin-left: auto;
          max-width: 70%;
        }
        
        @media (max-width: 768px) {
          .style-g .playful-section {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          
          .style-g .staggered-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
          
          .style-g .staggered-grid > div:last-child {
            margin-top: 0;
          }
          
          .style-g .offset-card:nth-child(even) {
            margin-left: 0;
          }
          
          .style-g .offset-card:nth-child(odd) {
            margin-right: 0;
          }
        }
      `}</style>
      
      <div className="asymmetric-container py-12">
        <header className="flowing-section">
          <div style={{maxWidth: '800px'}}>
            <h1>Dignified Contemporary</h1>
            <p className="contemporary-text">
              Professional design with <span className="creative-emphasis">personality</span> — 
              asymmetric layouts, varied alignment, and playful spacing create 
              an approachable yet <span className="dignified-accent">sophisticated presence</span>.
            </p>
          </div>
        </header>

        <section className="playful-section">
          <div>
            <h2>Unpretentious Layout</h2>
            <p className="contemporary-text">
              By breaking away from rigid center-alignment and symmetric grids, 
              we create a more relaxed, human feel while maintaining professional credibility.
            </p>
            <button className="contemporary-button">
              See the approach →
            </button>
          </div>
          
          <div>
            <div className="offset-card">
              <h3>Left-aligned headers</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                More conversational, less formal than centered text. Feels like natural reading flow.
              </p>
            </div>
            
            <div className="offset-card">
              <h3>Staggered content</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Subtle offset margins and varied widths create visual interest without chaos.
              </p>
            </div>
            
            <div className="offset-card">
              <h3>Breathing asymmetry</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.95rem'}}>
                Uneven but balanced layouts that feel more organic and approachable.
              </p>
            </div>
          </div>
        </section>

        <section className="layout-break">
          <h2>Design Philosophy</h2>
          <p className="contemporary-text">
            This approach recognizes that <span className="dignified-accent">dignity doesn't require rigidity</span>. 
            Cultural institutions can be authoritative and approachable, scholarly and human, 
            professional and unpretentious.
          </p>
          
          <div className="side-note">
            The best museum experiences feel like conversations with knowledgeable friends, 
            not lectures from distant authorities.
          </div>
        </section>

        <section className="flowing-section">
          <h2>Contemporary Elements</h2>
          
          <div className="staggered-grid">
            <div className="varied-alignment">
              <h3>Flexible Typography</h3>
              <p className="contemporary-text">
                Font weights and sizes that create hierarchy without being rigid. 
                Headers feel strong but not dominating.
              </p>
            </div>
            
            <div className="varied-alignment">
              <h3>Organic Spacing</h3>
              <p className="contemporary-text">
                Margins and padding that breathe naturally rather than following 
                mechanical grid rules.
              </p>
            </div>
          </div>
          
          <div style={{textAlign: 'right', maxWidth: '70%', marginLeft: 'auto', marginTop: '2rem'}}>
            <h3>Subtle Playfulness</h3>
            <p className="contemporary-text">
              Small touches — a hover animation here, an offset card there — 
              that add personality without sacrificing professionalism.
            </p>
          </div>
        </section>

        <section style={{margin: '4rem 0', padding: '3rem 0', background: 'var(--bg-secondary)', borderRadius: '12px', paddingLeft: '3rem'}}>
          <div style={{maxWidth: '800px'}}>
            <h2>Open & Dignified</h2>
            <p className="contemporary-text mb-4">
              Perfect for institutions that want to feel <span className="creative-emphasis">contemporary and accessible</span> 
              while maintaining the gravitas expected in cultural and academic settings.
            </p>
            <p className="contemporary-text">
              This aesthetic says: "We're serious about our work, but we don't take ourselves too seriously."
            </p>
            <button className="contemporary-button">
              Explore This Balance
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default StyleG;